
// Deployment trigger: 2026-04-24
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCf__rozJIy8QrUKeE2kiTtxvhCASeLKgw",
  authDomain: "myesalon-gamification.firebaseapp.com",
  projectId: "myesalon-gamification",
  storageBucket: "myesalon-gamification.firebasestorage.app",
  messagingSenderId: "930070946258",
  appId: "1:930070946258:web:37e03362f747bb6a39a80b",
  measurementId: "G-5BJE5YMC2F"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Secondary app instance for creating users without signing out the admin
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);

export { setPersistence, browserLocalPersistence, browserSessionPersistence };
